// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"215":"6ae3fe90585e504b5081","437":"da9b798ddbbbeee6914c","474":"4b47c64765be27ac5d06","529":"ca2b7ab6be2ae8a410f1","592":"b2cca95bd26fa9096b9a","775":"51d08e61220833a5fb20"}[chunkId] + ".js";
};